export default __webpack_public_path__ + "static/media/GLI_FREE.0c648986.png";